import { useContext, useEffect, useState, memo } from 'react'
import '../assets/css/Common.css'
import Category from '../components/Category'
import ArticlesContext from '../context/ArticlesContext'
import CategoryDropdownContext from '../context/CategoryDropdownContext'
import { Skeleton } from 'antd'

const Categories = memo(function Categories() {
    const {state} = useContext(ArticlesContext)
    const {closeDropdown, dropdownName} = useContext(CategoryDropdownContext)
    const [containerHeightClassName, setContainerHeightClassName] = useState("")

    useEffect(() => {
        setContainerHeightClassName(dropdownName === "" ? 'height-10vh' : 'height-40vh')
    }, [dropdownName])

    return(
        <div className='categories-div-placeholder top-margin-10'>
            <div className={`categories-div-container ${containerHeightClassName}`}>
            {state && !state.loading && state.categories ?
                (
                    <div className="flex-container categories-div" onMouseLeave={closeDropdown}>
                    {state.categories.map((category) => {
                        const categoryName = category.name
                        /** Categories that do not have subcategories */
                        if (categoryName === 'Članci i polemike' || categoryName === 'Promo') {
                            return <Category 
                                        key={category.id} 
                                        categoryName={categoryName} 
                                        subcategories={category.subcategories} 
                                        isDropdown={false} 
                                    />
                        }
                        return <Category 
                                    key={category.id} 
                                    categoryName={categoryName} 
                                    subcategories={category.subcategories}
                                />
                    })}
                    </div>
                )
                :
                (
                    <Skeleton active paragraph={{rows: 0}} title={{width: '100%'}}/>
                )
            }
            </div>
        </div>
    )
})

export default Categories